import React, {useState} from 'react';
import Helmet from 'react-helmet';
import {Button, TextField, Card, CardActions, CardContent, CardHeader} from '@material-ui/core';
import {resetPasswordCognito} from 'util/Authentication';

const styles = {
  span: {
    fontSize: 10,
  },
  p: {
    color: 'red',
    padding: '0px 20px',
    fontSize: 14,
  },
};

export default function ResetPassword(props) {
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const handleChangePassword = ({target: {value}}) => setPassword(value);
  const handleChangeCode = ({target: {value}}) => setCode(value);
  const handleReset = async () => {
    setErrorMessage('');
    if (password !== '' && code !== '') {
      try {
        await resetPasswordCognito(password, code);
      } catch (e) {
        setErrorMessage(e.message);
      }
    }
  };

  return (
    <div
      className="login_bg"
      style={{
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0% 30%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Helmet title="myOzgene" defer={false} />
      <Card
        style={{
          marginTop: '20px',
          padding: '20px 20px 20px 20px',
          backgroundColor: 'white',
          width: '300px',
        }}
      >
        <img
          src="/ozgene_logo.png"
          alt="logo"
          width="200"
          height="60"
          style={{
            marginRight: 'auto',
            marginLeft: 'auto',
            display: 'block',
          }}
        />

        <CardHeader title="Reset myOzgene password" />
        <p style={styles.p}>{errorMessage}</p>
        <CardContent>
          <span style={{fontSize: 'smaller'}}>
            Please enter a new password and the verification code sent to your email address.
          </span>
          <br />
          <TextField
            type="password"
            fullWidth
            placeholder="Enter your new Password"
            label="New Password"
            onChange={handleChangePassword}
          />
          <span style={styles.span}>Minimum 8 characters (alpha-numeric)</span>
          <br />
          <TextField
            placeholder="Enter the Code"
            fullWidth
            label="Verification Code"
            onChange={handleChangeCode}
          />
        </CardContent>
        <CardActions>
          <Button color="primary" variant="outlined" onClick={handleReset}>
            Reset
          </Button>
        </CardActions>
      </Card>
    </div>
  );
}
